import React from 'react';
import { Users, Wallet } from 'lucide-react';
import { Card, CardHeader } from '../ui';
import { formatMoney } from './formatters';

// Presentational: totals come from useOrgPortfolioTotals (summed from the same
// per-customer portfolios the Portfolio page shows), loaded once by Dashboard.
const AumPreviewCard = ({ loading = false, totals = null }) => {
  const currency = totals?.currency || 'AED';
  const total = totals?.totalPortfolioValue ?? 0;
  const investors = totals?.investors ?? 0;
  const avgPortfolioSize = investors > 0 ? total / investors : 0;

  return (
    <Card pad={false}>
      <CardHeader
        title="Assets under management"
        description="Total customer portfolio value held through your platform"
      />
      <div className="p-6 sm:p-8">
        <div>
          {loading ? (
            <span className="text-5xl font-semibold tracking-tight text-ink-300 tnum animate-pulse">—</span>
          ) : (
            <p className="text-5xl font-semibold tracking-tight text-ink-900 tnum">
              {formatMoney(total, currency, { compact: true })}
            </p>
          )}
          <p className="mt-1.5 text-xs text-ink-500">Across all customer portfolios, in {currency}</p>
        </div>

        <div className="mt-7 pt-6 border-t border-ink-100 grid grid-cols-2 gap-3 max-w-xs">
          <div className="rounded-lg border border-ink-100 bg-ink-50/60 p-3.5">
            <div className="flex items-center gap-1.5 text-ink-400">
              <Wallet className="h-3.5 w-3.5" />
              <p className="text-2xs font-semibold uppercase tracking-wider">Avg. portfolio</p>
            </div>
            {loading ? (
              <p className="mt-1.5 text-lg font-semibold text-ink-300 tnum animate-pulse">—</p>
            ) : (
              <p className="mt-1.5 text-lg font-semibold text-ink-900 tnum">
                {formatMoney(avgPortfolioSize, currency, { compact: true })}
              </p>
            )}
            <p className="text-xs text-ink-500">per investor</p>
          </div>
          <div className="rounded-lg border border-ink-100 bg-ink-50/60 p-3.5">
            <div className="flex items-center gap-1.5 text-ink-400">
              <Users className="h-3.5 w-3.5" />
              <p className="text-2xs font-semibold uppercase tracking-wider">Investors</p>
            </div>
            {loading ? (
              <p className="mt-1.5 text-lg font-semibold text-ink-300 tnum animate-pulse">—</p>
            ) : (
              <p className="mt-1.5 text-lg font-semibold text-ink-900 tnum">
                {investors.toLocaleString('en-US')}
              </p>
            )}
            <p className="text-xs text-ink-500">with a funded portfolio</p>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default AumPreviewCard;
